import { GovernmentCharges } from 'scenes/common/types';

export const defaultGovernmentCharges: GovernmentCharges = {
  gst: 0,
  fireServicesLevy: 0,
  stampDuty: 0,
};
